export default "__VITE_ASSET__jT62bSKx__"